module.exports = __webpack_public_path__ + "img/news.561fae0f.png";